import "./css/app.scss";
import 'cropperjs/dist/cropper.css';

import "./bootstrap"; 

// Import Vendor Libraries
import * as bootstrap from "bootstrap";
window.bootstrap = bootstrap;
import jQuery from "jquery";
import Cropper from "cropperjs";
import QrScanner from "qr-scanner";
import QrCreator from "qr-creator";
import DOMPurify from "dompurify";
import Swal from "sweetalert2";

// Expose to window for legacy support
window.$ = window.jQuery = jQuery;
window.Cropper = Cropper;
window.QrScanner = QrScanner;
window.QrCreator = QrCreator;
window.DOMPurify = DOMPurify;
window.Swal = Swal;

import "./index";
